/**
 * Component displaying AI execution token usage and duration metrics.
 */

import React from 'react'
import { Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import type { TokenUsage } from 'shared-libs/generated/server-types/entity/blocks/aiBlockUsageEntity'
import { formatDuration } from './ai-block-activity-helpers'

interface ITokenUsageInfoProps {
  tokenUsage?: TokenUsage
  duration?: number
}

export const TokenUsageInfo: React.FC<ITokenUsageInfoProps> = ({ tokenUsage, duration }) => {
  if (!tokenUsage && !duration) {
    return null
  }

  return (
    <div className='c-aiBlockResults-metaInfo'>
      {duration != null && (
        <span className='c-aiBlockResults-metaItem'>
          <Icon icon={IconNames.TIME} iconSize={12} />
          Duration: {formatDuration(duration)}
        </span>
      )}
      {tokenUsage && (
        <>
          <span className='c-aiBlockResults-metaItem'>
            <Icon icon={IconNames.TRENDING_UP} iconSize={12} />
            Tokens: {tokenUsage.total?.toLocaleString()} ({tokenUsage.input?.toLocaleString()} in, {tokenUsage.output?.toLocaleString()} out)
          </span>
        </>
      )}
    </div>
  )
}
